import { HttpClient } from '@angular/common/http';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { Component, Input, Output } from '@angular/core';
import { from } from 'rxjs';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions } from "ag-grid-community";
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { UserManagement } from '../../pages/user_management/user_management';
import { AlertController, Events, ModalController, ToastController, ViewController } from 'ionic-angular';

const mobileWidth = 600;
@Component({
  selector: 'watch-tab-view',
  templateUrl: 'watch-tab-view.html'
})
export class WatchTabViewComponent {

  columnDefs: ColDef[] = [
    { field: 'AccessId', sortable: true, filter: true, hide: true },
    { field: 'folderName', sortable: true, filter: true },
    { field: 'recordID', sortable: true, filter: true },
    { field: 'templateName', sortable: true, filter: true, hide: true },
    { field: 'senderName', sortable: true, filter: true },
    { field: 'date_time_modified', sortable: true, filter: true },
    { field: 'activityHistory', sortable: true, filter: true },
    { field: 'recordID', sortable: true, filter: true, hide: true },
  ];

  rowData: [];
  public gridOptions: GridOptions = {};
  folderPath: string;
  arrTemplateProps: any = [];
  pathIndex = 0;
  folderProp: any;
  selectedRowData: any = [];
  folderPropIndex: any;
  senderName: string;
  rowHeightSize = 28;
  date_time_modified: string;
  activityHistory: any;
  notes: string;
  attachment: string;
  constructor(private http: HttpClient,private viewCtrl: ViewController, public configApiService: ConfigApiServiceProvider, private alertCtrl: AlertController, public events: Events, private toastController: ToastController, public driveService: DriveServiceProvider, public configServiceProvider: ConfigureServiceProvider, private modal: ModalController) {
    this.gridOptions.rowHeight = this.rowHeightSize;
  }


  ngOnInit() {
    this.getWatchList();
  }

  getWatchList() {
    let objData = Object.assign({}, this.configApiService.driveApi.pullWatchTab.params, { 'userid': this.configServiceProvider.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'] })
    this.configApiService.pullRequest(objData, (respData) => {
      respData.forEach(element => {
      this.activityHistory = JSON.parse(element.activityHistory);
      if(this.activityHistory[0].notes == "") {
        this.attachment = this.activityHistory[0].attachment
        element['activityHistory'] = this.attachment
      } else {
        this.notes = this.activityHistory[0].notes;
        element['activityHistory'] = this.notes;
      }
      });
      this.rowData = respData
    })
  }

  rowClicked(rowdata) {
    this.selectedRowData = rowdata;
    this.senderName = rowdata.data.senderName;
    this.date_time_modified = rowdata.data.date_time_modified;
    this.folderPath = JSON.parse(rowdata.data.folderPath);
    this.openFolderComponent(rowdata)
    if (window.innerWidth < mobileWidth) {
      this.closeWatchTab();
     }
  }

  openFolderComponent(rowdata) {
    this.driveService.broadcastInfo({ src: 'main', event: 'loadPageComponent', page: 'Drive', status: true });
    this.getAppDriveStatus(rowdata)
  }

  getAppDriveStatus(rowdata) {
    let animation = (timer) => {
      if (this.driveService.activePageStatus) {
        this.driveService.watchTabFolderProps = rowdata['data'];
        this.driveService.gotoFolder(null);
        let folder: any = {};
        folder = JSON.parse(rowdata.data['folderProps']);
        this.getFolderData(folder);
        this.driveService.gotoFolder(this.folderProp);
        this.driveService.gotoBreadCrumbsFolder(this.folderProp.folder_id);
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: 'watchTab' });
        this.events.publish('openFolderContent', true)
        this.driveService.broadcastInfo({ src: 'main', event: 'showListView', data: true });
        cancelAnimationFrame(setInterval);
      } else {
        setInterval = window.requestAnimationFrame(animation);
      }
    }
    var setInterval = window.requestAnimationFrame(animation);
  }
  /******************
    * GET SPECIFIC FOLDER DATA
    * ********************* */
  getFolderData(objFolderSearch) {
    this.folderPropIndex = this.driveService.objRootFolder.folders.findIndex(folder => folder.folder_id == objFolderSearch.folder_id);
    if (this.folderPropIndex != -1) {
      this.folderProp = this.driveService.objRootFolder.folders.find(folder => folder.folder_id == objFolderSearch.folder_id);
      this.driveService.objCurrentFolder = this.folderProp;
    } else {
      this.searchCurrentFolderPath(objFolderSearch.path, this.driveService.objRootFolder.folders, objFolderSearch.folder_id, objFolderSearch);
      this.driveService.objCurrentFolder = this.folderProp;
    }
  }

  closeWatchTab() {
      this.viewCtrl.dismiss();
  }

  searchCurrentFolderPath(path, folder, folder_id, objFolderSearch) {
    for (var i = 1; i < path.length; i++) {
      if (folder.findIndex(ff => ff.folder_id == objFolderSearch.path[i]) != -1) {
        if (path.length - 1 == i) {
          folder = folder[folder.findIndex(ff => ff.folder_id == objFolderSearch.path[i])];
          this.driveService.gotoFolder(folder);
          this.folderProp = folder.folders.find(folderTemp => folderTemp.folder_id == folder_id);
          let parentFolder = folder;
          if (Object.keys(this.folderProp).length > 0) {
            this.driveService.objCurrentParentFolder = parentFolder;
          }
          break;
        } else {
          this.searchCurrentFolderPath(path[i], folder, folder_id, objFolderSearch);
        }
      } else {
        this.searchCurrentFolderPath(path[i], folder, folder_id, objFolderSearch)
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/components/watch-tab-view/watch-tab-view.ts